import Client from "./_client";

/**
 * Get CaseMaster tags, the option lists behind the case filters
 * @param {Object} filters - Supports `type` (single or comma separated) plus the
 *  usual pagination keys (pageNumber, pageSize, includeTotal)
 * @returns {Promise} Response data containing the casemasterTags page
 */
export const getCaseMasterTags = async (filters = {}) => {
  let url = "/casemasterTag?";

  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined) {
      if (Array.isArray(filters[key])) {
        url += `${key}=${filters[key].map(encodeURIComponent).join(',')}&`;
      } else {
        url += `${key}=${encodeURIComponent(filters[key])}&`;
      }
    }
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get filters. Please try again."
    );
  }

  return result?.data;
};
